import React from "react";

const Footer = () => {
  return (
    <div className="w-full flex justify-center text-gray-300 pb-4 ">
      <div className="text-lg shadow-lg bg-[#3b8399] shadow-[#0f1113da] w-[25%] justify-center items-center flex rounded-xl">
        Created with React.js and Tailwind CSS
      </div>
    </div>
  );
};

export default Footer;
